export default __webpack_public_path__ + "static/Delivering_Good_Logo-2@3x-05826d898e742f5c619d64cda79f012c.jpg";